export default {
    upgrade: {
        title: 'Choose the Right Plan for You',
        subtitle: 'Unlock professional features and boost your productivity.',
        pickYourPlan: 'Pick your plan',
        subscribeSuccess: 'Subscription successful',
        contactSales: 'Please contact our sales team for enterprise solutions.',
        enterpriseRestriction: 'Paid subscriptions are currently available for individual users only. Enterprise users, please contact our sales team for a tailored solution.',
        freeplanActivated: 'Basic plan is already active',
        planNotFound: 'Selected plan not found',
        alreadySubscribed: 'You are already subscribed to this plan',
        priceIdNotConfigured: 'Payment configuration not available for this plan',
        paymentInitFailed: 'Failed to initialize payment. Please try again.',
        maxPlan: {
            planName: 'Max',
            activeStatus: 'Active',
            cancelingStatus: 'Canceling',
            features: {
                unlimitedDrafting: 'Unlimited patent drafting documents',
                priorityWorkflow: 'Priority workflows for high-volume drafting',
            },
            billing: {
                title: 'Billing & Payment',
                cancelPlan: 'Cancel Plan',
                price: 'Price',
                period: 'Billing period',
                renewalDate: 'Renewal date',
                cancelDate: 'Cancel date',
                month: 'month',
                year: 'year',
            },
            cancel: {
                title: 'Cancel Max Plan',
                description: 'Your Max plan will remain active until the end of the current billing period.',
                keepPlan: 'Keep Plan',
                confirm: 'Confirm Cancellation',
                processing: 'Canceling...',
                otherPlaceholder: 'Tell us what happened',
                noSubscription: 'No active Max subscription was found.',
                success: 'Subscription canceled successfully. Your Max plan remains active until {date}.',
                failed: 'Failed to cancel subscription. Please try again.',
                reasons: {
                    tooExpensive: 'Too expensive',
                    missingFeatures: 'Missing features',
                    lowQuality: 'Low quality',
                    switchedToAnotherService: 'Switched to another service',
                    other: 'Other',
                },
            },
        },
        plans: {
            period: {
                monthly: ' / month',
                yearly: ' / year',
            },
            basic: {
                name: 'Basic',
                subtitle: 'Essential features for getting started',
                price: 'Free',
                description: 'Ideal for inventors and attorneys exploring AI-powered patent drafting.',
                button: 'Get Started',
                featuresHeader: 'Plan Features:',
                features: {
                    patentDraftingAgents: 'Access to Patent Drafting agents, including',
                    limitedHiroPrompts: 'AI editing with limited access to Hiro prompts',
                },
            },
            pro: {
                name: 'Pro',
                subtitle: 'Advanced tools for professionals',
                description: 'Accelerated drafting a prosecution workflow',
                button: 'Subscribe to Pro',
                moduleName: 'Pro Monthly / Yearly',
                yearlySavings: 'Save with annual billing',
                featuresHeader: 'Multiple drafting features to assist with global patent applications:',
                features: {
                    additionalHiroMessages: 'Additional Hiro messages',
                    fullDocumentExports: 'Full document exports',
                    disclosure1Doc: 'Invention Disclosure ({n} Doc)',
                    application1Doc: 'Patent Application ({n} Doc)',
                    oar1Doc: 'Office Action Response ({n} Doc)',
                },
            },
            max: {
                name: 'Max',
                subtitle: 'Unlimited document creation for high-volume work',
                description: 'Unlimited Usage for Drafting and Prosecution workflows.',
                button: 'Subscribe to Max',
                moduleName: 'Max Monthly / Yearly',
                yearlySavings: 'Save with annual billing',
                featuresHeader: 'Everything in Basic, plus:',
                features: {
                    unlimitedPatentDraftingAgents: 'Unlimited Usage for Patent Drafting Agents',
                },
            },
            enterprise: {
                name: 'Enterprise',
                subtitle: 'Organization-wide intelligence',
                price: 'Contact us',
                description: 'Scale patent operations across your entire team or organization.',
                button: 'Book a Demo',
                featuresHeader: 'Everything in Max, plus:',
                features: {
                    teamUsageHeader: 'Team usage & administration',
                    teamPooledCredits: 'Team-pooled credits with custom allocation',
                    adminConsole: 'Admin console for billing, usage, and user management',
                    collaborationHeader: 'Collaboration',
                    sharedWorkspaces: 'Shared workspaces and team projects',
                    teamWideIntelligence: 'Team-wide intelligence distribution',
                    governanceHeader: 'Governance & Security',
                    ssoSecurity: 'SSO and enterprise security controls',
                    rolePermissions: 'Role-based permissions for users and workspaces',
                    fileUploadControls: 'File upload controls',
                    privateIncognito: 'Private incognito mode',
                    serviceHeader: 'Service & Success',
                    dedicatedSupport: 'Dedicated customer support',
                    slaMonitoring: '99.9% SLA and proactive monitoring',
                },
                benefits: {
                    expandedSearch: 'Expanded search volume',
                    humanInLoop: 'Human-in-the-loop',
                    advancedEditor: 'Advanced inline editor',
                    workspaceIntegration: 'Workspace integration',
                    professionalExport: 'Professional document export',
                    evenMoreHiro: 'Even more Hiro Copilot messages',
                    ssoSecurity: 'SSO & advanced security',
                    dedicatedSuccess: 'Dedicated customer success manager',
                },
            },
            api: {
                name: 'Open platform',
                subtitle: 'Developer-first integration',
                price: 'Custom',
                description: 'Embed patent intelligence into your existing infrastructure.',
                button: 'Get API Key',
                featuresHeader: 'Developer capabilities:',
                features: {
                    apisHeader: 'APIs for custom workflows',
                    dataAiApis: '300+ data APIs and 60+ AI agent APIs across patents, life sciences, R&D, and market intelligence',
                    widgetsHeader: 'Drop-in UI Widgets',
                    dropInWidgets: 'Embed charts, insights, and AI workflows into your product - no rebuild required',
                    mcpHeader: 'MCP Servers for enterprise AI',
                    mcpServers: 'Connect trusted PatSnap tools through any MCP-compatible client, including Claude Desktop and Cursor',
                    skillsHeader: 'Agent Skills & SDKs',
                    agentSkillsSdks: 'Build and orchestrate workflows with LangChain, OpenClaw, CrewAI, and other frameworks',
                    playgroundHeader: 'Interactive Developer Playground',
                    developerPlayground: 'Explore scenario demos, test APIs, build widgets, and generate code in one place',
                },
            },
            features: {
                hiroMessages: 'Hiro Copilot messages',
                disclosure: 'Invention Disclosure',
                application: 'Patent Application',
                oar: 'Office Action Response',
                patentDrafting: 'Patent Drafting',
                disclosureUnlimited: 'Invention Disclosure (Unlimited)',
                patentDraftUnlimited: 'Patent Application (Unlimited)',
                oarDraftUnlimited: 'Office Action Response (Unlimited)',
                templateInstructionStyle: 'Template/Instruction/Style',
                customerTemplateInstructionStyle: 'Customer Template/Instruction/Style',
                exportWordDocuments: 'Export your drafted contents as Word documents',
                wordWpsPlugin: 'Include Eureka Pro ($200): full access to all Eureka agents',
            },
        },
        billingCycle: {
            monthly: 'Monthly',
            yearly: 'Yearly',
            shortSaveAmount: 'Save ${amount}',
            saveAmount: 'Yearly Saved ${amount}',
        },
        features: 'Features',
        benefits: 'Benefits',
        recommend: 'Recommend',
        comparison: {
            title: 'Compare Plans',
            plans: {
                guest: 'Guest',
                free: 'Basic',
                pro: 'Pro',
                max: 'Max',
                enterprise: 'Enterprise',
            },
            categories: {
                agent: 'Core Agent',
                features: 'Other Function',
                ai: 'AI Tool',
                security: 'Security & Control',
                collaboration: 'Enterprise Collaboration',
            },
            rows: {
                disclosure: 'Invention Disclosure',
                application: 'Patent Application',
                oar: 'Office Action Response',
                templates: 'Template',
                instructions: 'Instruction',
                styles: 'Style',
                draftingCenter: 'Drafting Center',
                officePlugin: 'Word Plugin (Coming soon)',
                aiChat: 'Hiro',
                chatLimitN: '{n} times/day',
                chatLimit500: '500 times/day',
                moreUsage: 'More limits',
                evenMoreUsage: 'Custom limits',
                createProject: 'Create Projects',
                exportProject: 'Export Projects',
                sharedAssets: 'Template/Instruction/Style Share',
                enterpriseManagement: 'Enterprise Management',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: 'Creating payment session...',
            errors: {
                createSessionFailed: 'Failed to create payment session. Please check your current account type.',
                verifyFailed: 'Failed to verify payment status',
                verificationFailed: 'Payment verification failed',
                verificationError: 'An error occurred during verification',
                invalidCallback: 'Invalid payment callback',
                noPriceId: 'Price information not configured',
            },
        },
    },
};
